import React from "react";
import "./Modal.scss";

const Modal = ({ show, onHide, children, size = "lg", zIndex = 1000 }) => {
  if (!show) return null;

  // Clone children to inject onHide to subcomponents like Modal.Header
  const enhancedChildren = React.Children.map(children, (child) => {
    if (React.isValidElement(child) && typeof child.type !== "symbol") {
      return React.cloneElement(child, { onHide });
    }
    return child;
  });
  return (
    <div className="modal-overlay" onClick={onHide} style={{ zIndex }}>
      <div
        className={`modal ${size}`}
        onClick={(e) => e.stopPropagation()}
        style={{ zIndex: zIndex + 1 }}
      >
        <div className="borderWrapper w-100 h-100">
          <div className="borderInner h-100">
            <div className="model-content">{enhancedChildren}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
